import { LogoLoader } from '@/components/ui/logo-loader';

// The app's default loading indicator. Renders the branded LogoLoader (animated
// logspot bars) instead of a generic spinner, so every `<Loader />` call site
// gets the logo treatment.
export function Loader({ fullScreen = false }: { fullScreen?: boolean }) {
  if (fullScreen) {
    return (
      <div
        className="bg-background fixed inset-0 z-50 flex items-center justify-center"
        data-testid="loader"
      >
        <LogoLoader />
      </div>
    );
  }

  return (
    <div
      className="flex min-h-full grow items-center justify-center"
      data-testid="loader"
    >
      <LogoLoader />
    </div>
  );
}
